import { render, staticRenderFns } from "./BusinessWorkHour.vue?vue&type=template&id=6ea62e80"
import script from "./BusinessWorkHour.vue?vue&type=script&lang=js"
export * from "./BusinessWorkHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports